import { initScanPage } from './pages/scan.js';
import { initAuthPage, initPasswordVisibilityToggles } from './pages/auth.js';
import { initVisitorShowPage } from './pages/visitor-show.js';
import { initAlerts } from './alerts.js';
import { initFinanceDashboardPage } from './pages/finance-dashboard.js';
import { initFinanceExpensesPage } from './pages/finance-expenses.js';


function detectPage() {
    // 1) Intenta por data-page.
    let page = document.body?.dataset?.page;


    // 2) Fallbacks por DOM
    if (!page) {
        if (document.getElementById('video')) page = 'scan';
        else if (document.querySelector('form[action="/auth/login"]')) page = 'login';
        else if (document.querySelector('form[action="/auth/register"]')) page = 'register';
    }


    // 3) Último recurso: 'scan'
    return page || 'scan';
}


export function bootstrap() {
    initAlerts();
    initPasswordVisibilityToggles();
    const page = detectPage();
    switch (page) {
        case 'scan':
            return initScanPage();
        case 'login':
        case 'register':
            return initAuthPage(page);
        case 'visitor-show':
            return initVisitorShowPage();
        case 'finance-dashboard':
            return initFinanceDashboardPage();
        case 'finance-expenses':
            return initFinanceExpensesPage();
        default:
            return;
    }
}
